import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  buttonClass: (props) => ({
    backgroundColor: props.customBgColor ? `${props.customBgColor} !important` : '#fff !important',
    border: 'none !important',
    margin: '10px 0px 8px 3px',

    '& .selected-flag': {
      backgroundColor: props.customBgColor && `${props.customBgColor} !important`,
    },
  }),
  inputClass: (props) => ({
    backgroundColor: props.customBgColor && `${props.customBgColor} !important`,
    border: 'none !important',
    height: '20px !important',
    width: '100% !important',
    paddingLeft: '55px !important',

    '&:focus-visible': {
      outline: 'none',
    },

    [theme.breakpoints.down('md')]: {
      width: '305px !important',
    },
  }),
  dropdownClass: {
    borderRadius: '10px !important',
    margin: '-252px 0px 10px -1px !important',
    display: 'grid',
    justifyItems: 'start',
  },
  textConfidential: {
    marginTop: theme.spacing(0.7),
    marginLeft: theme.spacing(1),
    color: '#9C9C9C',
  },
}));
